import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useToast } from "hooks/useToast";
import { useDeleteCustomReportMutation } from "store/apis/customReports";
import { BackendError } from "types/utils/error";

export const DeleteCustomReportModal = ({
  isOpen,
  close,
  reportId,
  onSuccess,
}: {
  isOpen: boolean;
  close: () => void;
  reportId: string;
  onSuccess?: () => void;
}) => {
  const entityId = useCurrentEntityId();
  const { alertToast, successToast } = useToast();
  const [deleteCustomReport, { isLoading }] = useDeleteCustomReportMutation();

  const handleDelete = async () => {
    try {
      await deleteCustomReport({ entityId, reportId }).unwrap();
      successToast({ message: "Report deleted successfully" });
      close();
      onSuccess?.();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Are you sure?">
          <div className="t-text-body-sm t-space-y-3">
            This action is irreversible, are you sure you want to proceed.
          </div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild disabled={isLoading}>
            <Button disabled={isLoading}>Cancel</Button>
          </Modal.RawClose>
          <Button
            customType="primary"
            onClick={handleDelete}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
